import React, { Component } from 'react'
import Context from './Context'
import CacheKeys from './cache/CacheKeys'
import CacheManager from './cache/CacheManager'
import LocalStorageKeys from './cache/LocalStorageKeys'
import SessionHelper from './contextHelper/SessionHelper'
import captureRequestParams from './contextHelper/captureRequestParams'

import AppUI from './AppUI'

class App extends Component {
  constructor(props) {
    super(props)
    this.className = 'App.js'
    this.state = {
      context: Context,
      unrecoverableError: null,
    }
  }

  render() {
    return (
      <AppUI
        context={this.state.context}
        unrecoverableError={this.state.unrecoverableError}
      />
    )
  }

  componentDidMount() {
    let context = this.state.context
    context.onLogin = this.onLogin
    context.onContextChange = this.onContextChange
    context.onUnrecoverableError = this.onUnrecoverableError

    this.retreiveLocalParams(context)
    captureRequestParams(context)
    let sessionHelper = new SessionHelper(context)
    sessionHelper.getSession()
    this.setState({context: context})
    console.log(this.className, 'componentDidMount', context);
    document.body.classList.add(this.state.context.theme)
  }

  retreiveLocalParams(context) {
    context.ecid = localStorage.getItem(LocalStorageKeys.ECID) || context.ecid
    localStorage.setItem(LocalStorageKeys.ECID, context.ecid)

    context.theme = localStorage.getItem(LocalStorageKeys.Theme) || context.theme

    context.apiHost = localStorage.getItem(LocalStorageKeys.APIHost) || context.apiHost
  }

  onContextChange = (context) => {
    this.setState({context: context})
    console.log(this.className, 'onContextChange', context)
  }

  onUnrecoverableError = (error) => {
    this.setState({unrecoverableError: error})
  }

  onLogin = (session, redirectImmediate) => {
    console.log(this.className, 'onLogin');
    if (session.errorList && session.errorList.length > 0) {
      this.state.context.onUnrecoverableError(session.errorList[0].message)
      return
    }
    localStorage.setItem(LocalStorageKeys.Session, JSON.stringify(session))
    localStorage.setItem(LocalStorageKeys.Session + ':CachedTime', Date.now()/1000)
    let context = this.state.context
    context.session = session

    // get permissions
    let cacheManager = new CacheManager({
      resource: `/api/user/accounts/${session.accountId}/permissions`,
      cacheKey: CacheKeys.Permissions(session.accountId, session.userId),
      callback: (response) => {
        this.getPermissionsCallback(response, redirectImmediate)
      },
      ttlInSecs: 3600
    })
    cacheManager.getObject2(this.state.context)
  }

  getPermissionsCallback = (response, redirectImmediate) => {
    console.log(redirectImmediate);
    let context = this.state.context
    context.permissions = response.permissionList
    this.setState({context: this.state.context})

    setTimeout(() => {
      if (response.permissionList.includes('su_view')) {
        window.location.href = '/su'
        return
      }
      let session = JSON.parse(localStorage.getItem(LocalStorageKeys.Session))
      switch (session.appCode) {
        case 'finapp':
          window.location.href = '/home'
          break
        case 'projectapp':
          window.location.href = '/projects'
          break
        default:
      }
    }, redirectImmediate ? 0 : 2000);
  }
}

export default App
